import React, { useRef, useState, useEffect } from "react";
import "../styles/genesis.css";

const timelineData = [
  {
    title: "MIIRA Framework",
    details: [
      "G20: Millet International Initiative for Research and Awareness (MIIRA)",
      "Suggested in Theme 1 of G20-AWG Issue Note",
      "Work in line with 2030 Agenda for SDGs",
    ],
    date: "December 2022",
  },
  {
    title: "Formulation of MAHARISHI",
    details: [
      "2nd Agriculture Deputies Meeting (ADM), AWG-G20",
      "Millets And Other Ancient Grains Research Initiative (MAHARISHI)",
      "Transformed MIIRA into MAHARISHI",
    ],
    date: "March 2023",
  },
  {
    title: "Incorporation in ODCS",
    details: [
      "G20 Agriculture Ministers Meeting (AMM)",
      "MAHARISHI welcomed by Agriculture Ministers during G20 AMM, Hyderabad",
      "Incorporated in Outcome Document & Chair Summary (ODCS)",
    ],
    date: "June 2023",
  },
  {
    title: "Inclusion in NDLD",
    details: [
      "G20 Summit, New Delhi",
      "G20 members encouraged efforts to strengthen research cooperation",
      "Agreed to form secretariat, based in IIMR, Hyderabad",
    ],
    date: "September 2023",
  },
  {
    title: "Secretariat Formation",
    details: [
      "Establish mechanisms to connect researchers and institutions",
      "Enhancing research dissemination and identifying gaps for identified crops",
    ],
    date: "Ongoing",
  },
];

const Timeline = () => {
  const stepsRef = useRef([]);
  const [visibleSteps, setVisibleSteps] = useState(new Set());

  useEffect(() => {
    const observers = stepsRef.current.map((el, index) => {
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisibleSteps((prev) => new Set([...prev, index]));
            obs.disconnect();
          }
        },
        { threshold: 0.3 }
      );
      obs.observe(el);
      return obs;
    });

    return () => observers.forEach((obs) => obs && obs.disconnect());
  }, []);

  return (
    <div className="genesis-page">
      {/* Page header */}
      <div className="genesis-header">
        <span className="genesis-label">Our Story</span>
        <h1 className="genesis-title">Genesis of MAHARISHI</h1>
        <p className="genesis-subtitle">
          A journey from concept to global research initiative
        </p>
      </div>

      {/* Timeline */}
      <div className="timeline-wrapper">
        <div className="timeline-container">
          {/* Horizontal center line */}
          <div className="timeline-line" />

          {timelineData.map((item, index) => {
            const isUp = index % 2 === 0;
            const isVisible = visibleSteps.has(index);

            return (
              <div
                key={index}
                ref={(el) => (stepsRef.current[index] = el)}
                className={`step ${isUp ? "step-up" : "step-down"} ${
                  isVisible ? "step-visible" : ""
                }`}
                style={{ "--delay": `${index * 0.15}s` }}
              >
                {/* Vertical connector stem */}
                <div className="step-stem" />

                {/* Center dot on the line */}
                <div className="step-dot">
                  <div className="step-dot-inner" />
                </div>

                {/* Content card */}
                <div className="step-card">
                  <div className="step-date">{item.date}</div>
                  <h3 className="step-title">{item.title}</h3>
                  <ul className="step-details">
                    {item.details.map((detail, i) => (
                      <li key={i}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Timeline;